import React from 'react'
import RegisteredProducts from '../account/registered-products'
import {useParams} from 'react-router-dom'
import {Box, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'

const GuestRegisteredProduct = () => {
    const styles = useMultiStyleConfig('Account')
    const {guestId} = useParams()

    return (
        <Box {...styles.guestRegisteredProductContainer}>
            <RegisteredProducts customer={{c_gigyaId: guestId}} isGuest={true} />
        </Box>
    )
}

export default GuestRegisteredProduct
